import { values } from '@/enums/enums'

const _enum = {
  NoType: 0,
  String: 1,
  Integer: 2,
  Number: 3,
  Date: 4,
  Bool: 5,
  PercentageInt: 6,
  PercentageDouble: 7,
  NumberUnformatted: 8
}

export const reportDataType = {
  enumName: 'ReportDataType',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/reportDataType.js